<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width400 full-height" header="Optionen">
        <sm-form  [form]="formFilter">
        </sm-form>
        <p-button icon="fas fa-filter" label="Filter" (onClick)="filter()"></p-button>
    </p-panel>
    <div *ngIf="wfTable != null" class="flex-item-fill flex-col">
        <sm-toolbar *ngIf="lastCall != null && lastCall.getVariables">
            <p-checkbox label="Variablen entrollen" name="unrollVariables" [(ngModel)]="unrollVariables" [binary]="true" (ngModelChange)="fillTable()"></p-checkbox>
        </sm-toolbar>
        <sm-table2 class="flex-item-fill" [data]="wfTable" [horizontalScroll]="hScroll" (onCellClicked)="cellClicked($event)">
        </sm-table2>
        <div class="mt-2">
            Anzahl gefundener Workflows: {{wfTable.rows.length}}
        </div>
    </div>
</div>
